import React from 'react';

import tagsIcon from '../../assets/img/icons/tags_icon.svg';
import {infoType} from '../../types/TypesNews';

import categories_icon from '../../assets/img/icons/categories_icon.png';
import {
	useGetCategoriesListQuery,
	useGetTagsListQuery,
} from '../../redux/newsApi';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

type Props = {
	handleChangeListItem?: any;
	newsTags?: infoType[] | null;
	newsCategories?: infoType[] | null;
};
const CategoriesAndTags: React.FC<Props> = ({
	handleChangeListItem,
	newsTags,
	newsCategories,
}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const {data: tagsResp} = useGetTagsListQuery();
	const {data: categoriesResp} = useGetCategoriesListQuery();
	const fetchedTags = tagsResp?.msg_tags || null;
	const fetchedCategories = categoriesResp?.msg_categories || null;

	const tagsList = newsTags ?? fetchedTags;
	const categoriesList = newsCategories ?? fetchedCategories;
	//const fixedList = useSelector((state: StateType) => state.newsData.fixedList)
	//const giveMeFixedList = useSelector(() => getFixedList)

	return (
		<div className="page__media-list media-list">
			<div className="media-list__row">
				{tagsList && (
					<div className="media-list__tags ">
						<div className="tags-media__item">
							<div className="tags-media__top">
								<div className="tags-media__title">{t('Список тегів')}</div>
								<div className="tags-media__icon">
									<img src={tagsIcon} alt="tag_icon" />
								</div>
							</div>
							<div className="tags-media__row">
								{tagsList?.map((tag: infoType) => {
									return (
										<div key={`tag${tag.id}`} className="tags-media__element">
											<button
												onClick={() => {
													if (handleChangeListItem) {
														handleChangeListItem(tag.id, 'tag');
													} else {
														navigate(`/news?tag=${tag.id}`);
													}
												}}
												className="tags-media__opportunities"
											>
												{tag.name}
											</button>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				)}
				{categoriesList && (
					<div className="media-list__categories ">
						<div className="categories-media__item">
							<div className="categories-media__top">
								<div className="categories-media__title">
									{t('Список категорій')}
								</div>
								<div className="categories-media__icon">
									<img src={categories_icon} alt="categories_icon" />
								</div>
							</div>
							<div className="categories-media__row">
								{categoriesList.map((category: infoType) => {
									return (
										<div
											key={`category${category.id}`}
											className="tags-media__element"
										>
											<button
												className="tags-media__opportunities"
												onClick={() => {
													if (handleChangeListItem) {
														handleChangeListItem(
															category.id,
															'category',
															category.name,
														);
													} else {
														navigate(`/news?category=${category.id}`);
													}
												}}
											>
												{category.name}
											</button>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default CategoriesAndTags;
